"use strict";

import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import loadingService from '@/services/loadingService';

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(BootstrapVue);

axios.interceptors.request.use((config) => {
  loadingService.showLoading(true);
  return config;
});

axios.interceptors.response.use((response) => {
  loadingService.showLoading(false);
  return response;
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js